namespace app.model.exporting {
  export class Endorsement {
    constructor(public readonly id: string, public readonly value: string, public readonly type: EndorsementType) {
    }
  }
}
